import type { UseMutationResult } from 'react-query';
import { useMutation } from 'react-query';

import type {
  IApiUpdateUserPasswordRequestBody,
  IApiUpdateUserPasswordResponseBody,
} from '../UsersApi.types';
import { useApi } from '~/lib/api/useApi';
import { useAuth } from '~/lib/auth';

export type IUseUpdateUserPasswordMutationValues = {
  body: IApiUpdateUserPasswordRequestBody;
};

export const useUpdateUserPasswordMutation = (): UseMutationResult<
  IApiUpdateUserPasswordResponseBody,
  unknown,
  IUseUpdateUserPasswordMutationValues
> => {
  const api = useApi();
  const auth = useAuth();

  return useMutation({
    mutationFn: (values) => api.users.updatePassword(values.body),
    onSuccess: () => auth.clearCredentials(),
  });
};
